import React from "react";
import { SvgIcon } from "@sscs/ui";
import {
  type IconColor,
  type IconSize,
  InactiveEntitlementIcon,
} from "@sscs/ui/icons";
import EntitlementActive from "Assets/images/badges/entitlement-active.svg";

// Map the legacy MUI fontSize this component accepts onto the icon size scale.
const ICON_SIZE: Record<string, IconSize> = {
  small: "sm",
  medium: "md",
  large: "lg",
  inherit: "inherit",
};

type EntitlementIconProps = {
  fontSize?: React.ComponentProps<typeof SvgIcon>["fontSize"];
  // Only the inactive glyph takes a colour — the active badge is a fixed asset.
  color?: IconColor;
  enabled: boolean;
};

const EntitlementIcon = ({
  fontSize = "small",
  color,
  enabled,
}: EntitlementIconProps): React.JSX.Element => {
  if (!enabled)
    return (
      <InactiveEntitlementIcon
        size={ICON_SIZE[fontSize ?? "small"]}
        color={color}
      />
    );

  // The active badge is a multi-color gradient asset, not a single-color glyph, so
  // it stays a raw SVG wrapped in SvgIcon.
  return (
    <SvgIcon fontSize={fontSize}>
      <EntitlementActive />
    </SvgIcon>
  );
};

export default EntitlementIcon;
